import React from "react";
import styles from "./account.module.css";
import facebook from "./facebook.svg";
import instagram from "./instagram.svg";
import twitter from "./images.png";
import { useI18nContext } from "../context/I18nContext";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";

const socialLinks = [
  {
    href: "https://www.facebook.com/profile.php?id=61552302150847",
    imgSrc: facebook,
    alt: "facebook",
    style: styles.facebook,
  },
  {
    href: "https://www.facebook.com/profile.php?id=61552302150847",
    imgSrc: instagram,
    alt: "instagram",
    style: styles.instagram,
  },
  {
    href: "https://www.facebook.com/profile.php?id=61552302150847",
    imgSrc: twitter,
    alt: "twitter",
    style: styles.twitter,
  },
];

const SocialIcons = () => {
  const { t, language } = useI18nContext();

  return (
    <div className={`${styles.flex} ${styles.socialIcons}`}>
      <div className={`${styles.flex} ${styles.followUs}`}>
        {Array.from(t("SocialIcons.followUs")).map(
          (letter, index) => (
            <span key={index}>{letter}</span>
          )
        )}
      </div>
      <div className={styles.iconContainer}>
        {socialLinks.map(({ href, imgSrc, alt, style }, index) => (
          <Link
            key={index}
            href={href}
            to={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={alt} 
          >
            <div className={`${styles.icon} ${style}`}>
              <Image src={imgSrc} alt={alt} />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SocialIcons;
